import React from 'react'
import { IoIosArrowForward } from 'react-icons/io';
import { IoArrowForward } from 'react-icons/io5';
import { Link } from 'react-router-dom';

const Adventures = () => {
  return (
    <>
      <section className="section-with-120px-margin">
        <div className="container">
          <div className="space-between-block-bottom">
            <div
              className="w-layout-vflex contents"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
            >
              <h2>Unlock Your Next Adventure</h2>
              <p className="margin-top-20px">
                We have been operating for over a decade, providing top-notch
                services to our clients and building a strong track record
              </p>
            </div>
            <div
              data-w-id="726343ef-957f-22da-ff20-1873f122997e"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
              className="slide-in-from-bottom-delayed"
            >
              <Link
                to="/services"
                data-w-id="d8d360e1-f645-321f-d65f-94a46da5403d"
                className="primary-button w-inline-block"
              >
                <div className="button-text-wrapper">
                  <div
                    className="default-text"
                    style={{
                      transform:
                        "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                  >
                    View More
                  </div>
                  <div
                    className="hover-text"
                    style={{
                      transform:
                        "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                      transformStyle: "preserve-3d",
                    }}
                  >
                    View More
                  </div>
                </div>

                <IoArrowForward />
                <div
                  className="button-hover"
                  style={{
                    width: "0%",
                    height: "58px",
                  }}
                ></div>
              </Link>
            </div>
          </div>
          <div
            data-w-id="df214c30-f30a-39de-6445-ef113730bccb"
            style={{
              opacity: 1,
              transform:
                "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
            }}
            className="banner-blocks-wrapper"
          >
            <div className="w-layout-vflex vertical-banners">
              <div className="horizontal-banner">
                <Link to="/elizabeth" className="banner-square w-inline-block">
                  <img
                    src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232670/culture_300x-100_duimit_p9mii7.jpg"
                    loading="lazy"
                    sizes="(max-width: 820px) 100vw, 820px"
                    srcSet="
                                https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232670/culture_300x-100_duimit_p9mii7.jpg
                            "
                    alt=""
                    className="image"
                  />
                  <div className="absolute-contents" style={{ height: "40%" }}>
                    <div className="_24px-text-white">Queen Elizabeth NP</div>
                    <p className="_14px-text-white">Southwest, Uganda</p>
                  </div>
                </Link>
                <Link to="/machison" className="banner-square w-inline-block">
                  <img
                    src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232658/exotic_300x-100_feef29_bcd2mn.jpg"
                    loading="lazy"
                    sizes="(max-width: 820px) 100vw, 820px"
                    srcSet="
                                https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232658/exotic_300x-100_feef29_bcd2mn.jpg
                            "
                    alt=""
                    className="image"
                  />
                  <div className="absolute-contents" style={{ height: "40%" }}>
                    <div className="_24px-text-white">Machismo Falls</div>
                    <p className="_14px-text-white">Northwestern, Uganda</p>
                  </div>
                </Link>
              </div>
              <Link to="/kidepo" className="banner-square w-inline-block">
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232626/alpine_iu76fy_r5plvp.jpg"
                  loading="lazy"
                  sizes="(max-width: 1700px) 100vw, 1700px"
                  srcSet="
                            https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232626/alpine_iu76fy_r5plvp.jpg
                        "
                  alt=""
                  className="image"
                />
                <div className="absolute-contents" style={{ height: "40%" }}>
                  <div className="_24px-text-white">Kidepo Valley</div>
                  <p className="_14px-text-white">Northwestern, Uganda</p>
                </div>
              </Link>
            </div>
            <div className="w-layout-vflex vertical-banners _410px">
              <div className="banner-square _502px">
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232603/40_jg1iv1_emf9hm.jpg"
                  loading="lazy"
                  sizes="(max-width: 820px) 100vw, 820px"
                  srcSet="
                            https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232603/40_jg1iv1_emf9hm.jpg
                        "
                  alt=""
                  className="image"
                  style={{
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                />
                <div className="absolute-center">
                  <div className="_43px-text-white">
                    All Kinds of Adventure <br />
                    Tours
                  </div>
                  <Link
                    to="/services"
                    data-w-id="6a02126f-c0a8-d659-d200-3ae14ccc73c4"
                    href="/destination"
                    className="tertiary-button w-inline-block"
                  >
                    <div className="button-text-wrapper">
                      <div
                        className="default-text"
                        style={{
                          transform:
                            "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      >
                        View Details
                      </div>
                      <div
                        className="hover-text"
                        style={{
                          transform:
                            "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      >
                        View Details
                      </div>
                    </div>
                    <div className="button-icon"></div>
                    <IoIosArrowForward />
                  </Link>
                </div>
              </div>
              <Link to="/elgon" className="banner-square w-inline-block">
                <img
                  src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232695/island_300x-100_o1keqe_qd3oml.jpg"
                  loading="lazy"
                  sizes="(max-width: 820px) 100vw, 820px"
                  srcSet="
                            https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232695/island_300x-100_o1keqe_qd3oml.jpg
                        "
                  alt=""
                  className="image"
                  style={{
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                />
                <div
                  className="absolute-contents"
                  style={{
                    height: "40%",
                    width: "410px",
                  }}
                >
                  <div className="_24px-text-white">Mt. Elgon NP</div>
                  <p className="_14px-text-white">Masaba Road, Uganda</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Adventures
